import React from 'react'
import './style/Stack.css'
import './style/bootstrap.min.css'


function Stack() {
  return (
    
      
      <div className="container stackContainer text-center">
         <h5 className="head">Skills & Tools</h5>
         <p className='skills'>The skills, tools and technologies I use to bring your products to life:</p>
           <div className="row r">
           <div className="col-md-3 col-sm-4 col-6  selemengts">
                 <div className="stackElement">
                     <img className="imageStack align-middle" width="50px" height="50px"  src="./img/springframwork.png"/>
                     <h5>Spring Framwork</h5>
                 </div>
             </div>  
             <div className="col-md-3 col-sm-4 col-6  selemengts">
                            <div className="stackElement">
                                <img className="imageStack" width="50px" height="50px" src="./img/java.png"/>
                                <h5>Java</h5>
                            </div>
            </div>

            <div className="col-md-3 col-sm-4 col-6  selemengts">
                            <div className="stackElement">
                                <img className="imageStack" width="50px" height="50px" src="./img/springboot.png"/>
                                <h5>Spring Boot</h5>
                            </div>
            </div>



            <div className="col-md-3 col-sm-4  col-6 selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="50px" height="50px" src="./img/angular.png"/>
                     <h5>Angular</h5>
                 </div>
             </div>

             <div className="col-md-3 col-sm-4 col-6  selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="50px" height="50px" src="./img/php (1).png"/>
                     <h5>PHP</h5>
                 </div>
             </div>
               
           
         
           <div className="col-md-3 col-sm-4 col-6  selemengts">
                 <div className="stackElement">
                     <img className="imageStack align-middle" width="50px" height="50px"  src="./img/laravel-logo.png"/>
                     <h5>Laravel</h5>
                 </div>
             </div>
          

             <div className="col-md-3 col-sm-4 col-6  selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="45px" height="45px" src="./img/photoshop.png"/>
                     <h5>Photoshop</h5>
                 </div>
             </div>
               
             <div className="col-md-3 col-sm-4 col-6  selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="45px" height="45px" src="./img/bootstrap (1).png"/>
                     <h5>Bootstrap</h5>
                  </div>
             </div>
             <div className="col-md-3 col-sm-4 col-6  selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="50px" height="50px" src="./img/git.png"/>
                     <h5>Git</h5>
                  </div>
             </div>

             <div className="col-md-3 col-sm-4 col-6  selemengts">
             <div className="stackElement">
                     <img className="imageStack" width="50px" height="50px" src="./img/github.png"/>
                     <h5>GitHub</h5>
                  </div>
             </div>
      
            
             
            

            
               
             

             
         
      </div>
     
    </div>
  );
}

export default Stack;
